define('uikit/config',{
  externalizeViewName: {
    enabled: true,
    nameAttribute: 'data-ui-name'
  }
});
